import { INTERESTS_STEP_PARENT_TAGS } from '../ChooseInterests/Business/constants'

import { MAIN_VIDEO, MAIN_VIDEO_DATA } from './constants'

export const getVideoData = (isBusiness = false, interests) => {
    if (isBusiness) {
        const tagNames = interests.map(item => item.name)
        const isHasEmployeeEngagementParentTag = tagNames.includes(INTERESTS_STEP_PARENT_TAGS.EMPLOYEE_ENGAGEMENT)
        const isHasNotEmployeeEngagementParentTag = tagNames.some(name =>
            [
                INTERESTS_STEP_PARENT_TAGS.MARKETING_CAMPAIGNS,
                INTERESTS_STEP_PARENT_TAGS.INTERACTIVE_CONTENT_FOR_WEB_AND_MOBILE,
                INTERESTS_STEP_PARENT_TAGS.EVENT_PRESENTATIONS_AND_TOUCHSCREEN_GAMES,
            ].includes(name),
        )

        if (isHasEmployeeEngagementParentTag && !isHasNotEmployeeEngagementParentTag)
            return MAIN_VIDEO_DATA[MAIN_VIDEO.BUSINESS_2]

        return MAIN_VIDEO_DATA[MAIN_VIDEO.BUSINESS_1]
    } else {
        return MAIN_VIDEO_DATA[MAIN_VIDEO.EDUCATION_1]
    }
}
